// frontend/src/services/catalogs.js
// Kleines, framework-freies Memo- und In-Flight-Caching.
// Jeder Getter liefert immer dieselbe Promise zurück, bis invalidate*() aufgerufen wird.

let subjectsPromise = null;
let subjectsCache = null;

let locationsPromise = null;
let locationsCache = null;

let usersPromise = null;
let usersCache = null;

export function invalidateCatalogs() {
  subjectsPromise = subjectsCache = null;
  locationsPromise = locationsCache = null;
  usersPromise = usersCache = null;
}

export function getSubjectsOnce(api) {
  if (subjectsCache) return Promise.resolve(subjectsCache);
  if (subjectsPromise) return subjectsPromise;
  subjectsPromise = api.get('/events/subjects')
    .then(r => {
      const j = r?.data ?? {};
      const list = Array.isArray(j.data) ? j.data : (Array.isArray(j) ? j : []);
      subjectsCache = list;
      return list;
    })
    .finally(() => { subjectsPromise = null; });
  return subjectsPromise;
}

export function getLocationsOnce(api) {
  if (locationsCache) return Promise.resolve(locationsCache);
  if (locationsPromise) return locationsPromise;
  locationsPromise = api.get('/events/locations')
    .then(r => {
      const j = r?.data ?? {};
      const list = Array.isArray(j.data) ? j.data : (Array.isArray(j) ? j : []);
      locationsCache = list;
      return list;
    })
    .finally(() => { locationsPromise = null; });
  return locationsPromise;
}

export function getUsersOnce(api) {
  if (usersCache) return Promise.resolve(usersCache);
  if (usersPromise) return usersPromise;

  // Statt /users → /users/assignable verwenden
  usersPromise = api.get('/users/assignable')
    .then(r => {
      const raw = r?.data;
      const list = Array.isArray(raw?.data)
        ? raw.data
        : (Array.isArray(raw) ? raw : []);
      usersCache = list || [];
      return usersCache;
    })
    .finally(() => { usersPromise = null; });

  return usersPromise;
}
